import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  .date {
    font-weight: 400;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  h2 {
    font-weight: 500;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[600]};
    margin-top: 8px;
  }

  .receivableContainer {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.yellow.light};

    border-radius: 8px;

    padding: 16px;
    margin: 24px 0;

    p {
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[600]};

      span {
        color: ${({ theme }) => theme.colors.orange.pressing};
        font-weight: 700;
      }
    }
  }

  .filtersContainer {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    gap: 24px;
  }

  .chartsContainer {
    display: flex;
    gap: 16px;
    margin-top: 32px;

    width: 100%;

    > div {
      width: 33%;
      min-width: 450px;
    }
  }
`;
